import React from 'react';
import ThemesDropdownItem from './ThemesDropdownItem';

const ThemesDropdownItems = ({ themes, value }) => (
  themes.map(({ code, name }) => (<ThemesDropdownItem key={`theme_${code}`} code={code} name={name} value={value} />))
);

export default ThemesDropdownItems;
